export const ROOT_ROUTE = '/';
export const AUTH_ROUTE = '/auth';
export const SIGN_UP_ROUTE = '/sign-up';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const DASHBOARD_ROUTE = '/dashboard';
export const EXAM_ROUTE = '/exam';
export const STUDENT_EXAM_ROUTE = '/student/:examId';
export const DOCUMENTATION_ROUTE = '/documentation';
export const TNC_ROUTE = '/terms-and-conditions';
export const PRIVACY_POLICY_ROUTE = '/privacy-policy';
export const NOT_FOUND_ROUTE = '*';
